// extracted by css-extract-rspack-plugin
export default {"button":"N0SzHm7Jq0NkHLCb","icon":"rprs7HVxQM9OcCwH"};